// extracted by mini-css-extract-plugin
export default {"container":"offlineModal_container__iRyCU","full_page":"offlineModal_full_page__LY7mz","button":"offlineModal_button__Yj5zu","offline_text":"offlineModal_offline_text__riMPZ"};